import { createFileRoute, Outlet } from "@tanstack/react-router"
import { Buildings, Factory } from "@phosphor-icons/react"

import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { Module } from "~/components/design-system/pages"
import type { ModuleTabsConfig } from "~/components/design-system/pages/types"
import { useOverallCapacity } from "~/hooks/useOverallCapacity"

export const Route = createFileRoute("/_auth/procurement/vendor-management/_layout")({
  component: VendorManagementModule,
})

function VendorManagementModule() {
  const { violations } = useOverallCapacity()
  const violationCount = violations.length

  const tabs: ModuleTabsConfig = {
    items: [
      {
        label: "Vendors",
        path: "/procurement/vendor-management/vendors" as never,
        icon: <Buildings />,
      },
      {
        label: "Capacity Plan",
        path: "/procurement/vendor-management/capacity" as never,
        icon: <Factory />,
        count: violationCount > 0 ? violationCount : undefined,
        countVariant: "red",
        tooltip:
          violationCount > 0
            ? `${violationCount} capacity ${violationCount === 1 ? "violation" : "violations"}`
            : undefined,
      },
    ],
    path: "/procurement/vendor-management" as never,
  }

  return (
    <Module breadcrumb={<BreadcrumbWrapper />} tabs={tabs}>
      <Outlet />
    </Module>
  )
}
